import { render, staticRenderFns } from "./ElectronicFilingStatementGA.vue?vue&type=template&id=04c648de"
import script from "./ElectronicFilingStatementGA.vue?vue&type=script&lang=ts"
export * from "./ElectronicFilingStatementGA.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports